/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ScanRouteImport } from './routes/scan'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as KitchenRouteImport } from './routes/kitchen'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminWebsiteRouteImport } from './routes/admin/website'
import { Route as AdminVoidLogRouteImport } from './routes/admin/void-log'
import { Route as AdminTradeRouteImport } from './routes/admin/trade'
import { Route as AdminTablesRouteImport } from './routes/admin/tables'
import { Route as AdminStationsRouteImport } from './routes/admin/stations'
import { Route as AdminStaffRouteImport } from './routes/admin/staff'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminServerRouteImport } from './routes/admin/server'
import { Route as AdminRiderRouteImport } from './routes/admin/rider'
import { Route as AdminReservationsRouteImport } from './routes/admin/reservations'
import { Route as AdminReportsRouteImport } from './routes/admin/reports'
import { Route as AdminReceiptsRouteImport } from './routes/admin/receipts'
import { Route as AdminProductionRouteImport } from './routes/admin/production'
import { Route as AdminOnlineOrdersRouteImport } from './routes/admin/online-orders'
import { Route as AdminMenuRouteImport } from './routes/admin/menu'
import { Route as AdminMarketingRouteImport } from './routes/admin/marketing'
import { Route as AdminKitchenFlowRouteImport } from './routes/admin/kitchen-flow'
import { Route as AdminKitchenRouteImport } from './routes/admin/kitchen'
import { Route as AdminInventoryRouteImport } from './routes/admin/inventory'
import { Route as AdminHrRouteImport } from './routes/admin/hr'
import { Route as AdminExpensesRouteImport } from './routes/admin/expenses'
import { Route as AdminDispatchRouteImport } from './routes/admin/dispatch'
import { Route as AdminDeliveryZonesRouteImport } from './routes/admin/delivery-zones'
import { Route as AdminDayCloseRouteImport } from './routes/admin/day-close'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as AdminCustomersRouteImport } from './routes/admin/customers'
import { Route as AdminCounterRouteImport } from './routes/admin/counter'
import { Route as AdminCateringRouteImport } from './routes/admin/catering'
import { Route as AdminCardPromosRouteImport } from './routes/admin/card-promos'
import { Route as AdminMarketingSegmentsRouteImport } from './routes/admin/marketing.segments'
import { Route as AdminMarketingReviewsRouteImport } from './routes/admin/marketing.reviews'
import { Route as AdminMarketingReputationRouteImport } from './routes/admin/marketing.reputation'
import { Route as AdminMarketingRecoveryRouteImport } from './routes/admin/marketing.recovery'
import { Route as AdminMarketingQrCodesRouteImport } from './routes/admin/marketing.qr-codes'
import { Route as AdminMarketingPromoCodesRouteImport } from './routes/admin/marketing.promo-codes'
import { Route as AdminMarketingPostersRouteImport } from './routes/admin/marketing.posters'
import { Route as AdminMarketingPerformanceRouteImport } from './routes/admin/marketing.performance'
import { Route as AdminMarketingOverviewRouteImport } from './routes/admin/marketing.overview'
import { Route as AdminMarketingMembersRouteImport } from './routes/admin/marketing.members'
import { Route as AdminMarketingLoyaltyRouteImport } from './routes/admin/marketing.loyalty'
import { Route as AdminMarketingKitsRouteImport } from './routes/admin/marketing.kits'
import { Route as AdminMarketingGiftCardsRouteImport } from './routes/admin/marketing.gift-cards'
import { Route as AdminMarketingEnrolmentRouteImport } from './routes/admin/marketing.enrolment'
import { Route as AdminMarketingCardPromosRouteImport } from './routes/admin/marketing.card-promos'
import { Route as AdminMarketingCampaignsRouteImport } from './routes/admin/marketing.campaigns'
import { Route as AdminMarketingCalendarRouteImport } from './routes/admin/marketing.calendar'
import { Route as AdminMarketingAutomationsRouteImport } from './routes/admin/marketing.automations'

const ScanRoute = ScanRouteImport.update({
  id: '/scan',
  path: '/scan',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const KitchenRoute = KitchenRouteImport.update({
  id: '/kitchen',
  path: '/kitchen',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminWebsiteRoute = AdminWebsiteRouteImport.update({
  id: '/website',
  path: '/website',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVoidLogRoute = AdminVoidLogRouteImport.update({
  id: '/void-log',
  path: '/void-log',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTradeRoute = AdminTradeRouteImport.update({
  id: '/trade',
  path: '/trade',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTablesRoute = AdminTablesRouteImport.update({
  id: '/tables',
  path: '/tables',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStationsRoute = AdminStationsRouteImport.update({
  id: '/stations',
  path: '/stations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStaffRoute = AdminStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminServerRoute = AdminServerRouteImport.update({
  id: '/server',
  path: '/server',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRiderRoute = AdminRiderRouteImport.update({
  id: '/rider',
  path: '/rider',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReservationsRoute = AdminReservationsRouteImport.update({
  id: '/reservations',
  path: '/reservations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReceiptsRoute = AdminReceiptsRouteImport.update({
  id: '/receipts',
  path: '/receipts',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProductionRoute = AdminProductionRouteImport.update({
  id: '/production',
  path: '/production',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOnlineOrdersRoute = AdminOnlineOrdersRouteImport.update({
  id: '/online-orders',
  path: '/online-orders',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMenuRoute = AdminMenuRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMarketingRoute = AdminMarketingRouteImport.update({
  id: '/marketing',
  path: '/marketing',
  getParentRoute: () => AdminRoute,
} as any)
const AdminKitchenFlowRoute = AdminKitchenFlowRouteImport.update({
  id: '/kitchen-flow',
  path: '/kitchen-flow',
  getParentRoute: () => AdminRoute,
} as any)
const AdminKitchenRoute = AdminKitchenRouteImport.update({
  id: '/kitchen',
  path: '/kitchen',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInventoryRoute = AdminInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AdminRoute,
} as any)
const AdminHrRoute = AdminHrRouteImport.update({
  id: '/hr',
  path: '/hr',
  getParentRoute: () => AdminRoute,
} as any)
const AdminExpensesRoute = AdminExpensesRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDispatchRoute = AdminDispatchRouteImport.update({
  id: '/dispatch',
  path: '/dispatch',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDeliveryZonesRoute = AdminDeliveryZonesRouteImport.update({
  id: '/delivery-zones',
  path: '/delivery-zones',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDayCloseRoute = AdminDayCloseRouteImport.update({
  id: '/day-close',
  path: '/day-close',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCustomersRoute = AdminCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCounterRoute = AdminCounterRouteImport.update({
  id: '/counter',
  path: '/counter',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCateringRoute = AdminCateringRouteImport.update({
  id: '/catering',
  path: '/catering',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCardPromosRoute = AdminCardPromosRouteImport.update({
  id: '/card-promos',
  path: '/card-promos',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMarketingSegmentsRoute = AdminMarketingSegmentsRouteImport.update({
  id: '/segments',
  path: '/segments',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingReviewsRoute = AdminMarketingReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingReputationRoute =
  AdminMarketingReputationRouteImport.update({
    id: '/reputation',
    path: '/reputation',
    getParentRoute: () => AdminMarketingRoute,
  } as any)
const AdminMarketingRecoveryRoute = AdminMarketingRecoveryRouteImport.update({
  id: '/recovery',
  path: '/recovery',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingQrCodesRoute = AdminMarketingQrCodesRouteImport.update({
  id: '/qr-codes',
  path: '/qr-codes',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingPromoCodesRoute =
  AdminMarketingPromoCodesRouteImport.update({
    id: '/promo-codes',
    path: '/promo-codes',
    getParentRoute: () => AdminMarketingRoute,
  } as any)
const AdminMarketingPostersRoute = AdminMarketingPostersRouteImport.update({
  id: '/posters',
  path: '/posters',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingPerformanceRoute =
  AdminMarketingPerformanceRouteImport.update({
    id: '/performance',
    path: '/performance',
    getParentRoute: () => AdminMarketingRoute,
  } as any)
const AdminMarketingOverviewRoute = AdminMarketingOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingMembersRoute = AdminMarketingMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingLoyaltyRoute = AdminMarketingLoyaltyRouteImport.update({
  id: '/loyalty',
  path: '/loyalty',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingKitsRoute = AdminMarketingKitsRouteImport.update({
  id: '/kits',
  path: '/kits',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingGiftCardsRoute = AdminMarketingGiftCardsRouteImport.update({
  id: '/gift-cards',
  path: '/gift-cards',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingEnrolmentRoute = AdminMarketingEnrolmentRouteImport.update({
  id: '/enrolment',
  path: '/enrolment',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingCardPromosRoute =
  AdminMarketingCardPromosRouteImport.update({
    id: '/card-promos',
    path: '/card-promos',
    getParentRoute: () => AdminMarketingRoute,
  } as any)
const AdminMarketingCampaignsRoute = AdminMarketingCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingCalendarRoute = AdminMarketingCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingAutomationsRoute =
  AdminMarketingAutomationsRouteImport.update({
    id: '/automations',
    path: '/automations',
    getParentRoute: () => AdminMarketingRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/kitchen': typeof KitchenRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/scan': typeof ScanRoute
  '/admin/card-promos': typeof AdminCardPromosRoute
  '/admin/catering': typeof AdminCateringRoute
  '/admin/counter': typeof AdminCounterRoute
  '/admin/customers': typeof AdminCustomersRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/day-close': typeof AdminDayCloseRoute
  '/admin/delivery-zones': typeof AdminDeliveryZonesRoute
  '/admin/dispatch': typeof AdminDispatchRoute
  '/admin/expenses': typeof AdminExpensesRoute
  '/admin/hr': typeof AdminHrRoute
  '/admin/inventory': typeof AdminInventoryRoute
  '/admin/kitchen': typeof AdminKitchenRoute
  '/admin/kitchen-flow': typeof AdminKitchenFlowRoute
  '/admin/marketing': typeof AdminMarketingRouteWithChildren
  '/admin/menu': typeof AdminMenuRoute
  '/admin/online-orders': typeof AdminOnlineOrdersRoute
  '/admin/production': typeof AdminProductionRoute
  '/admin/receipts': typeof AdminReceiptsRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/reservations': typeof AdminReservationsRoute
  '/admin/rider': typeof AdminRiderRoute
  '/admin/server': typeof AdminServerRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/stations': typeof AdminStationsRoute
  '/admin/tables': typeof AdminTablesRoute
  '/admin/trade': typeof AdminTradeRoute
  '/admin/void-log': typeof AdminVoidLogRoute
  '/admin/website': typeof AdminWebsiteRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/marketing/automations': typeof AdminMarketingAutomationsRoute
  '/admin/marketing/calendar': typeof AdminMarketingCalendarRoute
  '/admin/marketing/campaigns': typeof AdminMarketingCampaignsRoute
  '/admin/marketing/card-promos': typeof AdminMarketingCardPromosRoute
  '/admin/marketing/enrolment': typeof AdminMarketingEnrolmentRoute
  '/admin/marketing/gift-cards': typeof AdminMarketingGiftCardsRoute
  '/admin/marketing/kits': typeof AdminMarketingKitsRoute
  '/admin/marketing/loyalty': typeof AdminMarketingLoyaltyRoute
  '/admin/marketing/members': typeof AdminMarketingMembersRoute
  '/admin/marketing/overview': typeof AdminMarketingOverviewRoute
  '/admin/marketing/performance': typeof AdminMarketingPerformanceRoute
  '/admin/marketing/posters': typeof AdminMarketingPostersRoute
  '/admin/marketing/promo-codes': typeof AdminMarketingPromoCodesRoute
  '/admin/marketing/qr-codes': typeof AdminMarketingQrCodesRoute
  '/admin/marketing/recovery': typeof AdminMarketingRecoveryRoute
  '/admin/marketing/reputation': typeof AdminMarketingReputationRoute
  '/admin/marketing/reviews': typeof AdminMarketingReviewsRoute
  '/admin/marketing/segments': typeof AdminMarketingSegmentsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/kitchen': typeof KitchenRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/scan': typeof ScanRoute
  '/admin/card-promos': typeof AdminCardPromosRoute
  '/admin/catering': typeof AdminCateringRoute
  '/admin/counter': typeof AdminCounterRoute
  '/admin/customers': typeof AdminCustomersRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/day-close': typeof AdminDayCloseRoute
  '/admin/delivery-zones': typeof AdminDeliveryZonesRoute
  '/admin/dispatch': typeof AdminDispatchRoute
  '/admin/expenses': typeof AdminExpensesRoute
  '/admin/hr': typeof AdminHrRoute
  '/admin/inventory': typeof AdminInventoryRoute
  '/admin/kitchen': typeof AdminKitchenRoute
  '/admin/kitchen-flow': typeof AdminKitchenFlowRoute
  '/admin/marketing': typeof AdminMarketingRouteWithChildren
  '/admin/menu': typeof AdminMenuRoute
  '/admin/online-orders': typeof AdminOnlineOrdersRoute
  '/admin/production': typeof AdminProductionRoute
  '/admin/receipts': typeof AdminReceiptsRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/reservations': typeof AdminReservationsRoute
  '/admin/rider': typeof AdminRiderRoute
  '/admin/server': typeof AdminServerRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/stations': typeof AdminStationsRoute
  '/admin/tables': typeof AdminTablesRoute
  '/admin/trade': typeof AdminTradeRoute
  '/admin/void-log': typeof AdminVoidLogRoute
  '/admin/website': typeof AdminWebsiteRoute
  '/admin': typeof AdminIndexRoute
  '/admin/marketing/automations': typeof AdminMarketingAutomationsRoute
  '/admin/marketing/calendar': typeof AdminMarketingCalendarRoute
  '/admin/marketing/campaigns': typeof AdminMarketingCampaignsRoute
  '/admin/marketing/card-promos': typeof AdminMarketingCardPromosRoute
  '/admin/marketing/enrolment': typeof AdminMarketingEnrolmentRoute
  '/admin/marketing/gift-cards': typeof AdminMarketingGiftCardsRoute
  '/admin/marketing/kits': typeof AdminMarketingKitsRoute
  '/admin/marketing/loyalty': typeof AdminMarketingLoyaltyRoute
  '/admin/marketing/members': typeof AdminMarketingMembersRoute
  '/admin/marketing/overview': typeof AdminMarketingOverviewRoute
  '/admin/marketing/performance': typeof AdminMarketingPerformanceRoute
  '/admin/marketing/posters': typeof AdminMarketingPostersRoute
  '/admin/marketing/promo-codes': typeof AdminMarketingPromoCodesRoute
  '/admin/marketing/qr-codes': typeof AdminMarketingQrCodesRoute
  '/admin/marketing/recovery': typeof AdminMarketingRecoveryRoute
  '/admin/marketing/reputation': typeof AdminMarketingReputationRoute
  '/admin/marketing/reviews': typeof AdminMarketingReviewsRoute
  '/admin/marketing/segments': typeof AdminMarketingSegmentsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/kitchen': typeof KitchenRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/scan': typeof ScanRoute
  '/admin/card-promos': typeof AdminCardPromosRoute
  '/admin/catering': typeof AdminCateringRoute
  '/admin/counter': typeof AdminCounterRoute
  '/admin/customers': typeof AdminCustomersRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/day-close': typeof AdminDayCloseRoute
  '/admin/delivery-zones': typeof AdminDeliveryZonesRoute
  '/admin/dispatch': typeof AdminDispatchRoute
  '/admin/expenses': typeof AdminExpensesRoute
  '/admin/hr': typeof AdminHrRoute
  '/admin/inventory': typeof AdminInventoryRoute
  '/admin/kitchen': typeof AdminKitchenRoute
  '/admin/kitchen-flow': typeof AdminKitchenFlowRoute
  '/admin/marketing': typeof AdminMarketingRouteWithChildren
  '/admin/menu': typeof AdminMenuRoute
  '/admin/online-orders': typeof AdminOnlineOrdersRoute
  '/admin/production': typeof AdminProductionRoute
  '/admin/receipts': typeof AdminReceiptsRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/reservations': typeof AdminReservationsRoute
  '/admin/rider': typeof AdminRiderRoute
  '/admin/server': typeof AdminServerRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/stations': typeof AdminStationsRoute
  '/admin/tables': typeof AdminTablesRoute
  '/admin/trade': typeof AdminTradeRoute
  '/admin/void-log': typeof AdminVoidLogRoute
  '/admin/website': typeof AdminWebsiteRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/marketing/automations': typeof AdminMarketingAutomationsRoute
  '/admin/marketing/calendar': typeof AdminMarketingCalendarRoute
  '/admin/marketing/campaigns': typeof AdminMarketingCampaignsRoute
  '/admin/marketing/card-promos': typeof AdminMarketingCardPromosRoute
  '/admin/marketing/enrolment': typeof AdminMarketingEnrolmentRoute
  '/admin/marketing/gift-cards': typeof AdminMarketingGiftCardsRoute
  '/admin/marketing/kits': typeof AdminMarketingKitsRoute
  '/admin/marketing/loyalty': typeof AdminMarketingLoyaltyRoute
  '/admin/marketing/members': typeof AdminMarketingMembersRoute
  '/admin/marketing/overview': typeof AdminMarketingOverviewRoute
  '/admin/marketing/performance': typeof AdminMarketingPerformanceRoute
  '/admin/marketing/posters': typeof AdminMarketingPostersRoute
  '/admin/marketing/promo-codes': typeof AdminMarketingPromoCodesRoute
  '/admin/marketing/qr-codes': typeof AdminMarketingQrCodesRoute
  '/admin/marketing/recovery': typeof AdminMarketingRecoveryRoute
  '/admin/marketing/reputation': typeof AdminMarketingReputationRoute
  '/admin/marketing/reviews': typeof AdminMarketingReviewsRoute
  '/admin/marketing/segments': typeof AdminMarketingSegmentsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/forgot-password'
    | '/kitchen'
    | '/login'
    | '/reset-password'
    | '/scan'
    | '/admin/card-promos'
    | '/admin/catering'
    | '/admin/counter'
    | '/admin/customers'
    | '/admin/dashboard'
    | '/admin/day-close'
    | '/admin/delivery-zones'
    | '/admin/dispatch'
    | '/admin/expenses'
    | '/admin/hr'
    | '/admin/inventory'
    | '/admin/kitchen'
    | '/admin/kitchen-flow'
    | '/admin/marketing'
    | '/admin/menu'
    | '/admin/online-orders'
    | '/admin/production'
    | '/admin/receipts'
    | '/admin/reports'
    | '/admin/reservations'
    | '/admin/rider'
    | '/admin/server'
    | '/admin/settings'
    | '/admin/staff'
    | '/admin/stations'
    | '/admin/tables'
    | '/admin/trade'
    | '/admin/void-log'
    | '/admin/website'
    | '/admin/'
    | '/admin/marketing/automations'
    | '/admin/marketing/calendar'
    | '/admin/marketing/campaigns'
    | '/admin/marketing/card-promos'
    | '/admin/marketing/enrolment'
    | '/admin/marketing/gift-cards'
    | '/admin/marketing/kits'
    | '/admin/marketing/loyalty'
    | '/admin/marketing/members'
    | '/admin/marketing/overview'
    | '/admin/marketing/performance'
    | '/admin/marketing/posters'
    | '/admin/marketing/promo-codes'
    | '/admin/marketing/qr-codes'
    | '/admin/marketing/recovery'
    | '/admin/marketing/reputation'
    | '/admin/marketing/reviews'
    | '/admin/marketing/segments'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/kitchen'
    | '/login'
    | '/reset-password'
    | '/scan'
    | '/admin/card-promos'
    | '/admin/catering'
    | '/admin/counter'
    | '/admin/customers'
    | '/admin/dashboard'
    | '/admin/day-close'
    | '/admin/delivery-zones'
    | '/admin/dispatch'
    | '/admin/expenses'
    | '/admin/hr'
    | '/admin/inventory'
    | '/admin/kitchen'
    | '/admin/kitchen-flow'
    | '/admin/marketing'
    | '/admin/menu'
    | '/admin/online-orders'
    | '/admin/production'
    | '/admin/receipts'
    | '/admin/reports'
    | '/admin/reservations'
    | '/admin/rider'
    | '/admin/server'
    | '/admin/settings'
    | '/admin/staff'
    | '/admin/stations'
    | '/admin/tables'
    | '/admin/trade'
    | '/admin/void-log'
    | '/admin/website'
    | '/admin'
    | '/admin/marketing/automations'
    | '/admin/marketing/calendar'
    | '/admin/marketing/campaigns'
    | '/admin/marketing/card-promos'
    | '/admin/marketing/enrolment'
    | '/admin/marketing/gift-cards'
    | '/admin/marketing/kits'
    | '/admin/marketing/loyalty'
    | '/admin/marketing/members'
    | '/admin/marketing/overview'
    | '/admin/marketing/performance'
    | '/admin/marketing/posters'
    | '/admin/marketing/promo-codes'
    | '/admin/marketing/qr-codes'
    | '/admin/marketing/recovery'
    | '/admin/marketing/reputation'
    | '/admin/marketing/reviews'
    | '/admin/marketing/segments'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/forgot-password'
    | '/kitchen'
    | '/login'
    | '/reset-password'
    | '/scan'
    | '/admin/card-promos'
    | '/admin/catering'
    | '/admin/counter'
    | '/admin/customers'
    | '/admin/dashboard'
    | '/admin/day-close'
    | '/admin/delivery-zones'
    | '/admin/dispatch'
    | '/admin/expenses'
    | '/admin/hr'
    | '/admin/inventory'
    | '/admin/kitchen'
    | '/admin/kitchen-flow'
    | '/admin/marketing'
    | '/admin/menu'
    | '/admin/online-orders'
    | '/admin/production'
    | '/admin/receipts'
    | '/admin/reports'
    | '/admin/reservations'
    | '/admin/rider'
    | '/admin/server'
    | '/admin/settings'
    | '/admin/staff'
    | '/admin/stations'
    | '/admin/tables'
    | '/admin/trade'
    | '/admin/void-log'
    | '/admin/website'
    | '/admin/'
    | '/admin/marketing/automations'
    | '/admin/marketing/calendar'
    | '/admin/marketing/campaigns'
    | '/admin/marketing/card-promos'
    | '/admin/marketing/enrolment'
    | '/admin/marketing/gift-cards'
    | '/admin/marketing/kits'
    | '/admin/marketing/loyalty'
    | '/admin/marketing/members'
    | '/admin/marketing/overview'
    | '/admin/marketing/performance'
    | '/admin/marketing/posters'
    | '/admin/marketing/promo-codes'
    | '/admin/marketing/qr-codes'
    | '/admin/marketing/recovery'
    | '/admin/marketing/reputation'
    | '/admin/marketing/reviews'
    | '/admin/marketing/segments'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  KitchenRoute: typeof KitchenRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  ScanRoute: typeof ScanRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/scan': {
      id: '/scan'
      path: '/scan'
      fullPath: '/scan'
      preLoaderRoute: typeof ScanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kitchen': {
      id: '/kitchen'
      path: '/kitchen'
      fullPath: '/kitchen'
      preLoaderRoute: typeof KitchenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/website': {
      id: '/admin/website'
      path: '/website'
      fullPath: '/admin/website'
      preLoaderRoute: typeof AdminWebsiteRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/void-log': {
      id: '/admin/void-log'
      path: '/void-log'
      fullPath: '/admin/void-log'
      preLoaderRoute: typeof AdminVoidLogRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/trade': {
      id: '/admin/trade'
      path: '/trade'
      fullPath: '/admin/trade'
      preLoaderRoute: typeof AdminTradeRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/tables': {
      id: '/admin/tables'
      path: '/tables'
      fullPath: '/admin/tables'
      preLoaderRoute: typeof AdminTablesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/stations': {
      id: '/admin/stations'
      path: '/stations'
      fullPath: '/admin/stations'
      preLoaderRoute: typeof AdminStationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/staff': {
      id: '/admin/staff'
      path: '/staff'
      fullPath: '/admin/staff'
      preLoaderRoute: typeof AdminStaffRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/server': {
      id: '/admin/server'
      path: '/server'
      fullPath: '/admin/server'
      preLoaderRoute: typeof AdminServerRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/rider': {
      id: '/admin/rider'
      path: '/rider'
      fullPath: '/admin/rider'
      preLoaderRoute: typeof AdminRiderRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reservations': {
      id: '/admin/reservations'
      path: '/reservations'
      fullPath: '/admin/reservations'
      preLoaderRoute: typeof AdminReservationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/receipts': {
      id: '/admin/receipts'
      path: '/receipts'
      fullPath: '/admin/receipts'
      preLoaderRoute: typeof AdminReceiptsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/production': {
      id: '/admin/production'
      path: '/production'
      fullPath: '/admin/production'
      preLoaderRoute: typeof AdminProductionRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/online-orders': {
      id: '/admin/online-orders'
      path: '/online-orders'
      fullPath: '/admin/online-orders'
      preLoaderRoute: typeof AdminOnlineOrdersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/menu': {
      id: '/admin/menu'
      path: '/menu'
      fullPath: '/admin/menu'
      preLoaderRoute: typeof AdminMenuRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/marketing': {
      id: '/admin/marketing'
      path: '/marketing'
      fullPath: '/admin/marketing'
      preLoaderRoute: typeof AdminMarketingRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/kitchen-flow': {
      id: '/admin/kitchen-flow'
      path: '/kitchen-flow'
      fullPath: '/admin/kitchen-flow'
      preLoaderRoute: typeof AdminKitchenFlowRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/kitchen': {
      id: '/admin/kitchen'
      path: '/kitchen'
      fullPath: '/admin/kitchen'
      preLoaderRoute: typeof AdminKitchenRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/inventory': {
      id: '/admin/inventory'
      path: '/inventory'
      fullPath: '/admin/inventory'
      preLoaderRoute: typeof AdminInventoryRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/hr': {
      id: '/admin/hr'
      path: '/hr'
      fullPath: '/admin/hr'
      preLoaderRoute: typeof AdminHrRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/expenses': {
      id: '/admin/expenses'
      path: '/expenses'
      fullPath: '/admin/expenses'
      preLoaderRoute: typeof AdminExpensesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dispatch': {
      id: '/admin/dispatch'
      path: '/dispatch'
      fullPath: '/admin/dispatch'
      preLoaderRoute: typeof AdminDispatchRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/delivery-zones': {
      id: '/admin/delivery-zones'
      path: '/delivery-zones'
      fullPath: '/admin/delivery-zones'
      preLoaderRoute: typeof AdminDeliveryZonesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/day-close': {
      id: '/admin/day-close'
      path: '/day-close'
      fullPath: '/admin/day-close'
      preLoaderRoute: typeof AdminDayCloseRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/customers': {
      id: '/admin/customers'
      path: '/customers'
      fullPath: '/admin/customers'
      preLoaderRoute: typeof AdminCustomersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/counter': {
      id: '/admin/counter'
      path: '/counter'
      fullPath: '/admin/counter'
      preLoaderRoute: typeof AdminCounterRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/catering': {
      id: '/admin/catering'
      path: '/catering'
      fullPath: '/admin/catering'
      preLoaderRoute: typeof AdminCateringRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/card-promos': {
      id: '/admin/card-promos'
      path: '/card-promos'
      fullPath: '/admin/card-promos'
      preLoaderRoute: typeof AdminCardPromosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/marketing/segments': {
      id: '/admin/marketing/segments'
      path: '/segments'
      fullPath: '/admin/marketing/segments'
      preLoaderRoute: typeof AdminMarketingSegmentsRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/reviews': {
      id: '/admin/marketing/reviews'
      path: '/reviews'
      fullPath: '/admin/marketing/reviews'
      preLoaderRoute: typeof AdminMarketingReviewsRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/reputation': {
      id: '/admin/marketing/reputation'
      path: '/reputation'
      fullPath: '/admin/marketing/reputation'
      preLoaderRoute: typeof AdminMarketingReputationRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/recovery': {
      id: '/admin/marketing/recovery'
      path: '/recovery'
      fullPath: '/admin/marketing/recovery'
      preLoaderRoute: typeof AdminMarketingRecoveryRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/qr-codes': {
      id: '/admin/marketing/qr-codes'
      path: '/qr-codes'
      fullPath: '/admin/marketing/qr-codes'
      preLoaderRoute: typeof AdminMarketingQrCodesRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/promo-codes': {
      id: '/admin/marketing/promo-codes'
      path: '/promo-codes'
      fullPath: '/admin/marketing/promo-codes'
      preLoaderRoute: typeof AdminMarketingPromoCodesRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/posters': {
      id: '/admin/marketing/posters'
      path: '/posters'
      fullPath: '/admin/marketing/posters'
      preLoaderRoute: typeof AdminMarketingPostersRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/performance': {
      id: '/admin/marketing/performance'
      path: '/performance'
      fullPath: '/admin/marketing/performance'
      preLoaderRoute: typeof AdminMarketingPerformanceRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/overview': {
      id: '/admin/marketing/overview'
      path: '/overview'
      fullPath: '/admin/marketing/overview'
      preLoaderRoute: typeof AdminMarketingOverviewRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/members': {
      id: '/admin/marketing/members'
      path: '/members'
      fullPath: '/admin/marketing/members'
      preLoaderRoute: typeof AdminMarketingMembersRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/loyalty': {
      id: '/admin/marketing/loyalty'
      path: '/loyalty'
      fullPath: '/admin/marketing/loyalty'
      preLoaderRoute: typeof AdminMarketingLoyaltyRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/kits': {
      id: '/admin/marketing/kits'
      path: '/kits'
      fullPath: '/admin/marketing/kits'
      preLoaderRoute: typeof AdminMarketingKitsRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/gift-cards': {
      id: '/admin/marketing/gift-cards'
      path: '/gift-cards'
      fullPath: '/admin/marketing/gift-cards'
      preLoaderRoute: typeof AdminMarketingGiftCardsRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/enrolment': {
      id: '/admin/marketing/enrolment'
      path: '/enrolment'
      fullPath: '/admin/marketing/enrolment'
      preLoaderRoute: typeof AdminMarketingEnrolmentRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/card-promos': {
      id: '/admin/marketing/card-promos'
      path: '/card-promos'
      fullPath: '/admin/marketing/card-promos'
      preLoaderRoute: typeof AdminMarketingCardPromosRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/campaigns': {
      id: '/admin/marketing/campaigns'
      path: '/campaigns'
      fullPath: '/admin/marketing/campaigns'
      preLoaderRoute: typeof AdminMarketingCampaignsRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/calendar': {
      id: '/admin/marketing/calendar'
      path: '/calendar'
      fullPath: '/admin/marketing/calendar'
      preLoaderRoute: typeof AdminMarketingCalendarRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/automations': {
      id: '/admin/marketing/automations'
      path: '/automations'
      fullPath: '/admin/marketing/automations'
      preLoaderRoute: typeof AdminMarketingAutomationsRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
  }
}

interface AdminMarketingRouteChildren {
  AdminMarketingAutomationsRoute: typeof AdminMarketingAutomationsRoute
  AdminMarketingCalendarRoute: typeof AdminMarketingCalendarRoute
  AdminMarketingCampaignsRoute: typeof AdminMarketingCampaignsRoute
  AdminMarketingCardPromosRoute: typeof AdminMarketingCardPromosRoute
  AdminMarketingEnrolmentRoute: typeof AdminMarketingEnrolmentRoute
  AdminMarketingGiftCardsRoute: typeof AdminMarketingGiftCardsRoute
  AdminMarketingKitsRoute: typeof AdminMarketingKitsRoute
  AdminMarketingLoyaltyRoute: typeof AdminMarketingLoyaltyRoute
  AdminMarketingMembersRoute: typeof AdminMarketingMembersRoute
  AdminMarketingOverviewRoute: typeof AdminMarketingOverviewRoute
  AdminMarketingPerformanceRoute: typeof AdminMarketingPerformanceRoute
  AdminMarketingPostersRoute: typeof AdminMarketingPostersRoute
  AdminMarketingPromoCodesRoute: typeof AdminMarketingPromoCodesRoute
  AdminMarketingQrCodesRoute: typeof AdminMarketingQrCodesRoute
  AdminMarketingRecoveryRoute: typeof AdminMarketingRecoveryRoute
  AdminMarketingReputationRoute: typeof AdminMarketingReputationRoute
  AdminMarketingReviewsRoute: typeof AdminMarketingReviewsRoute
  AdminMarketingSegmentsRoute: typeof AdminMarketingSegmentsRoute
}

const AdminMarketingRouteChildren: AdminMarketingRouteChildren = {
  AdminMarketingAutomationsRoute: AdminMarketingAutomationsRoute,
  AdminMarketingCalendarRoute: AdminMarketingCalendarRoute,
  AdminMarketingCampaignsRoute: AdminMarketingCampaignsRoute,
  AdminMarketingCardPromosRoute: AdminMarketingCardPromosRoute,
  AdminMarketingEnrolmentRoute: AdminMarketingEnrolmentRoute,
  AdminMarketingGiftCardsRoute: AdminMarketingGiftCardsRoute,
  AdminMarketingKitsRoute: AdminMarketingKitsRoute,
  AdminMarketingLoyaltyRoute: AdminMarketingLoyaltyRoute,
  AdminMarketingMembersRoute: AdminMarketingMembersRoute,
  AdminMarketingOverviewRoute: AdminMarketingOverviewRoute,
  AdminMarketingPerformanceRoute: AdminMarketingPerformanceRoute,
  AdminMarketingPostersRoute: AdminMarketingPostersRoute,
  AdminMarketingPromoCodesRoute: AdminMarketingPromoCodesRoute,
  AdminMarketingQrCodesRoute: AdminMarketingQrCodesRoute,
  AdminMarketingRecoveryRoute: AdminMarketingRecoveryRoute,
  AdminMarketingReputationRoute: AdminMarketingReputationRoute,
  AdminMarketingReviewsRoute: AdminMarketingReviewsRoute,
  AdminMarketingSegmentsRoute: AdminMarketingSegmentsRoute,
}

const AdminMarketingRouteWithChildren = AdminMarketingRoute._addFileChildren(
  AdminMarketingRouteChildren,
)

interface AdminRouteChildren {
  AdminCardPromosRoute: typeof AdminCardPromosRoute
  AdminCateringRoute: typeof AdminCateringRoute
  AdminCounterRoute: typeof AdminCounterRoute
  AdminCustomersRoute: typeof AdminCustomersRoute
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminDayCloseRoute: typeof AdminDayCloseRoute
  AdminDeliveryZonesRoute: typeof AdminDeliveryZonesRoute
  AdminDispatchRoute: typeof AdminDispatchRoute
  AdminExpensesRoute: typeof AdminExpensesRoute
  AdminHrRoute: typeof AdminHrRoute
  AdminInventoryRoute: typeof AdminInventoryRoute
  AdminKitchenRoute: typeof AdminKitchenRoute
  AdminKitchenFlowRoute: typeof AdminKitchenFlowRoute
  AdminMarketingRoute: typeof AdminMarketingRouteWithChildren
  AdminMenuRoute: typeof AdminMenuRoute
  AdminOnlineOrdersRoute: typeof AdminOnlineOrdersRoute
  AdminProductionRoute: typeof AdminProductionRoute
  AdminReceiptsRoute: typeof AdminReceiptsRoute
  AdminReportsRoute: typeof AdminReportsRoute
  AdminReservationsRoute: typeof AdminReservationsRoute
  AdminRiderRoute: typeof AdminRiderRoute
  AdminServerRoute: typeof AdminServerRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminStaffRoute: typeof AdminStaffRoute
  AdminStationsRoute: typeof AdminStationsRoute
  AdminTablesRoute: typeof AdminTablesRoute
  AdminTradeRoute: typeof AdminTradeRoute
  AdminVoidLogRoute: typeof AdminVoidLogRoute
  AdminWebsiteRoute: typeof AdminWebsiteRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminCardPromosRoute: AdminCardPromosRoute,
  AdminCateringRoute: AdminCateringRoute,
  AdminCounterRoute: AdminCounterRoute,
  AdminCustomersRoute: AdminCustomersRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminDayCloseRoute: AdminDayCloseRoute,
  AdminDeliveryZonesRoute: AdminDeliveryZonesRoute,
  AdminDispatchRoute: AdminDispatchRoute,
  AdminExpensesRoute: AdminExpensesRoute,
  AdminHrRoute: AdminHrRoute,
  AdminInventoryRoute: AdminInventoryRoute,
  AdminKitchenRoute: AdminKitchenRoute,
  AdminKitchenFlowRoute: AdminKitchenFlowRoute,
  AdminMarketingRoute: AdminMarketingRouteWithChildren,
  AdminMenuRoute: AdminMenuRoute,
  AdminOnlineOrdersRoute: AdminOnlineOrdersRoute,
  AdminProductionRoute: AdminProductionRoute,
  AdminReceiptsRoute: AdminReceiptsRoute,
  AdminReportsRoute: AdminReportsRoute,
  AdminReservationsRoute: AdminReservationsRoute,
  AdminRiderRoute: AdminRiderRoute,
  AdminServerRoute: AdminServerRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminStaffRoute: AdminStaffRoute,
  AdminStationsRoute: AdminStationsRoute,
  AdminTablesRoute: AdminTablesRoute,
  AdminTradeRoute: AdminTradeRoute,
  AdminVoidLogRoute: AdminVoidLogRoute,
  AdminWebsiteRoute: AdminWebsiteRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  KitchenRoute: KitchenRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ScanRoute: ScanRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
